import React from 'react';
import PropTypes from 'prop-types';
import {
  SettingsOutlined as SettingsIcon,
  ScheduleOutlined as ScheduleIcon,
  CameraAltOutlined as CameraIcon
} from '@material-ui/icons';
import { IconButton, makeStyles, Tooltip } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  }
}))



function Control(props) {
  const { takePhoto, openSettingsDialog, openTimesegmentsDialog } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Tooltip title='Take Photo'>
        <IconButton onClick={() => takePhoto()}>
          <CameraIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title='Site Settings'>
        <IconButton onClick={() => openSettingsDialog(true)}>
          <SettingsIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title='Timesegments'>
        <IconButton onClick={() => openTimesegmentsDialog(true)}>
          <ScheduleIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
}

Control.propTypes = {
  takePhoto: PropTypes.func,
  openSettingsDialog: PropTypes.func,
  openTimesegmentsDialog: PropTypes.func
}

export default Control;
